import { useIdleGuard } from '@/hooks/useIdleGuard';

type IdleGuardProps = {
  enabled: boolean;
};

/** Không render UI — chỉ chạy logic idle timeout. */
export function IdleGuard({ enabled }: IdleGuardProps) {
  useIdleGuard(enabled);
  return null;
}
